import React, { Component } from 'react';
import RequestQuotationForm from '../forms/RequestQuotationForm';
import Breadcrumb from '../navs/Breadcrumb';
import Footer from '../navs/Footer';
import NavBar from '../navs/Navbar';

class RequestQuotation extends Component {

    render() {
        return (
            <div>
                <NavBar />
                <Breadcrumb />
                <div>
                    <section className="portfolio-details mt-n5" style={{ padding: '20px' }}>
                        <div className="container">
                            <div className="row" style={{ marginBottom: '0' }}>

                                <div className="col-md-4" data-aos="fade-up">
                                    <img src="assets/img/services/slice 4.png" className="img-fluid" alt="" style={{ width: "14em" }} />
                                    <div className="portfolio-description">
                                        <p>You can use the request for quotation (RFQ) procedure to request us  provide you with an offer for goods and services.</p>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <section id="blog" className="blog">
                                        <div className="container-fl">
                                            <div className="row">
                                                <div className="col-lg-12  col-md-10 d-flex align-items-stretch entry" data-aos="fade-up">
                                                    <RequestQuotationForm />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        )
    }


}

export default RequestQuotation;
